import { render, staticRenderFns } from "./CancellationReasons.vue?vue&type=template&id=6bc33adb&"
import script from "./CancellationReasons.vue?vue&type=script&lang=js&"
export * from "./CancellationReasons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports